<template>
  <div class="settle-account-row">
    <div class="settle-account-table">
      <vxe-grid
        border
        show-overflow
        resizable
        ref="SurchargeRow"
        class="vxe-table-element"
        size="mini"
        align="center"
        :auto-resize="true"
        :data="tableData"
        :toolbar="{}"
        :valid-config="{ autoPos: true, message: 'inline' }"
        @radio-change="handleSelectionChange"
        height="260"
      >
        <!-- :edit-config="{ trigger: 'click', mode: 'row'}" -->

        <vxe-table-column type="radio" width="50" fixed="left"> </vxe-table-column>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in tableColumnList"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          :sortable="item.sortable"
          :edit-render="item.editRender"
        >
          <template v-slot="{ row }">
            <span v-if="item.editRender.name == 'hasExceptionExpense'">{{
              row['hasExceptionExpense'] == '0' ? '无' : '有'
            }}</span>
            <span v-else-if="item.editRender.name == 'unit'">{{
              basic_unit?.find((item) => item.value == row['unit'])?.label
            }}</span>
            <span v-else>{{ row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </vxe-grid>
      <!-- 分页 -->
      <IPagination
        :total="tableTotal"
        :multipleSelection="selectionList"
        @changePageHandler="changePageHandler"
      />
    </div>
  </div>
</template>

<script>
  import { tableColumnList, tableRules } from './index.js';
  // import BASEAPI from '@/api/dataBase.js';
  // import baseUrl from '@/common/config';
  // import RECEIVABLES_TRADE from '@/api/receivablesAndPayables/trade.js';
  export default {
    name: 'SurchargeRow',
    props: {
      // 获取后端数据反填上去
      unusualList: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        tableTotal: 0,
        selectionList: [],
        tableData: [],
        tableRules,
        tableColumnList,
        currencyList: [],
        uploadData: {}, // 上传参数
        uploadUrl: '',
        action: '',
        isFetchTableData: false,
        deleteLineIds: [], //删除行的ids
      };
    },
    computed: {
      basic_unit() {
        return this.dictListMap.basic_unit;
      },
      tableStatus() {
        return ['detail', 'edit'].includes(this.$route.query.status) ? this.linesData.length : true;
      },
    },
    methods: {
      handleSelectionChange({ row }) {
        this.selectionList = [row];
        console.log(this.selectionList, 'this.selectionList');
        // 选择行
        this.$emit('selectionRowHandler', row);
      },
      changePageHandler(pageNum, pageSize) {
        console.log(pageNum, pageSize);
      },
      getTableData() {
        const $table = this.$refs.SurchargeRow;
        return $table.getTableData().fullData;
      },

      // 反填远程返回的数据
      fullFetchTableData(val) {
        // 只需要处理一次,采用查重数组或者定义一个变量方式处理

        this.$nextTick(() => {
          const $table = this.$refs.SurchargeRow;
          $table.remove(this.getTableData()); //先删除表格所有数据
          console.log(val, '查看');
          $table?.insertAt(val, 0);
        });
      },
    },
    mounted() {},
    watch: {
      // currentDetailData: {
      //   handler(val) {
      //     this.fullTableData(val);
      //   },
      //   // immediate: true,
      //   deep: true,
      // },
      unusualList: {
        handler(val) {
          if (val && Array.isArray(val) && val.length) {
            this.fullFetchTableData(val);
          }
        },
        immediate: true,
        deep: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .settle-account-row {
    background: #fff;
    .settle-account-table {
      padding: 10px;
      box-sizing: border-box;
      padding-top: 0;
    }
  }
  ::v-deep {
    .vxe-toolbar.size--mini {
      display: none;
    }
  }
</style>
